
<script>
export default {
  name: 'UserProfile',
  computed: {
    userProfile() {
      return this.$store.getters['profile/getUserProfile']
    },
  },
  methods: {
    showUserForm() {
      this.$store.commit('myAgency/changeShowUserForm', true)
    }
  }
}
</script>

<template>
  <div class="my-agency__content">
    <div class="my-agency__user-info">
      <img
        v-if="userProfile.image"
        :src="userProfile.image"
        alt=""
      >
      <img
        v-else
        src="@/assets/images/default.jpg"
        alt=""
      >
      <div>
        <p>{{ userProfile.fullname }}</p>
      </div>
    </div>
    <div class="my-agency__form-table">
      <div class="my-agency__form-table-row">
        <div class="my-agency__form-table-label">
          <p>Телефон рабочий</p>
        </div>
        <div class="my-agency__form-table-content">
          <p>{{ userProfile.phone }}</p>
        </div>
      </div>
      <div class="my-agency__form-table-row">
        <div class="my-agency__form-table-label">
          <p>E-mail</p>
        </div>
        <div class="my-agency__form-table-content">
          <p>{{ userProfile.email }}</p>
        </div>
      </div>
    </div>
    <div class="my-agency__edit-user">
      <a
        href="javascript:;"
        class="rex-btn rex-btn--bold"
        @click="showUserForm"
      >
        <span>Редактировать</span>
      </a>
    </div>
  </div>
</template>